import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import StatusIcon from './icon/icon';
import {whiteEx} from '../../../assets/symbols/symbols/Symbols.css';
import {openWhatsApp} from '../../../library/whatsApp';
import {BRIGHT_RED} from '../../../globalVariables/GlobalVariables';
import {useTranslation} from 'react-i18next';
import Card from './card/card';

const Failed = () => {
    const {t}=useTranslation('suspendedConfirmation');
    return (
        <Card mainTitle={undefined} subTitle={undefined} >
            <css.confirmationBox>
                <StatusIcon icon={whiteEx} color={BRIGHT_RED} />
                <css.errorTitle>
                    {t('errorTitle')}
                </css.errorTitle>
                <css.boldTextCenter>
                    {t('errorDescription1')}
                    <br />
                    {t('errorDescription2')}
                </css.boldTextCenter>
            </css.confirmationBox>
            <css.buttonRow>
                <Btn onClick={()=>window.location.reload()}>{t('retry')}</Btn>
                <Btn className="white" onClick={()=>openWhatsApp('972559979022')}>{t('supportContact')}</Btn>
            </css.buttonRow>
        </Card>
    );
};

export default Failed;